/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, {
    useState, useRef, useEffect, useCallback,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';

function IndentFilterModal({
    filterModal, setFilterModal, selected, setselected, Filter, setFilter, handleFilter, handleIndentReports, setfilterValue, filterValue, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const [selectedType, setselectedType] = useState('customer_category');
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleClear = () => {
        setFilter({
            customer_category: [],
            order_category: [],
            wf_status: [],
            type: [],
            date_range: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        handleIndentReports();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'customer_category':
                if (Filter[key].length > 0) {
                    final += `&customer_category=${createUrl(Filter[key])}`;
                }
                break;
            case 'order_category':
                if (Filter[key].length > 0) {
                    final += `&order_category=${createUrl(Filter[key])}`;
                }
                break;
            case 'wf_status':
                if (Filter[key].length > 0) {
                    final += `&wf_status=${createUrl(Filter[key])}`;
                }
                break;
            case 'type':
                if (Filter[key].length > 0) {
                    final += `&type=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date_range=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[35%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('customer_category')}>
                                    <a
                                        href="javascript:void(0)"
                                        className={`nav-link block ${selectedType === 'customer_category' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-pricetab"
                                        aria-selected="true"
                                    >
                                        Customer Category
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={() => setselectedType('order_category')}>
                                    <a
                                        href="javascript:void(0)"
                                        className={`nav-link block text-base ${selectedType === 'order_category' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-size"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-sizemm"
                                        role="tab"
                                        aria-controls="pills-sizemm"
                                        aria-selected="false"
                                    >
                                        Order Category
                                    </a>
                                </li>
                                {/* <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('type')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'type' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilltype"
                                        role="tab"
                                        aria-controls="pilltype"
                                        aria-selected="false"
                                    >
                                        Type
                                    </a>
                                </li> */}
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('date_range')}>
                                    <a
                                        href="javascript:void(0)"
                                        className={`nav-link block ${selectedType === 'date_range' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-daterange"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilldaterange"
                                        role="tab"
                                        aria-controls="pilldaterange"
                                        aria-selected="false"
                                    >
                                        Date Range
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[65%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'customer_category' ? 'show active' : ''} fade px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_category?.includes('Direct') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.customer_category?.includes('Direct')}
                                                    onChange={() => HandleFilter('customer_category', 'Direct')}
                                                    borderColor={`${Filter.customer_category?.includes('Direct') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn1" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Direct Customer</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_category?.includes('Trade') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.customer_category?.includes('Trade')}
                                                    onChange={() => HandleFilter('customer_category', 'Trade')}
                                                    borderColor={`${Filter.customer_category?.includes('Trade') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Distributor(Trade)</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_category?.includes('Trade EUB') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.customer_category?.includes('Trade EUB')}
                                                    onChange={() => HandleFilter('customer_category', 'Trade EUB')}
                                                    borderColor={`${Filter.customer_category?.includes('Trade EUB') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Distributor(Trade EUB)</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selectedType === 'order_category' ? 'show active' : ''} w-full overflow-auto h-[190px] sidebar`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="ml-5 cursor-pointer">
                                        <div className="flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('CONSUMABLES') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_category?.includes('CONSUMABLES')}
                                                onChange={() => HandleFilter('order_category', 'CONSUMABLES')}
                                                borderColor={`${Filter.order_category?.includes('CONSUMABLES') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="xs2" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Consumables</label>
                                        </div>
                                        <div className="flex items-center mt-[14px] mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('EQUIPMENTS_SGP') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_category?.includes('EQUIPMENTS_SGP')}
                                                onChange={() => HandleFilter('order_category', 'EQUIPMENTS_SGP')}
                                                borderColor={`${Filter.order_category?.includes('EQUIPMENTS_SGP') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="xs3" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Equipment/Spares</label>
                                        </div>
                                        <div
                                            className="relative flex items-center mt-[14px] mb-3"
                                            onClick={() => HandleFilter('order_category', 'MnR')}
                                        >
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('MnR') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_category.includes('MnR')}
                                                borderColor={`${Filter.order_category.includes('MnR') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="xs3" data-testid="equipment-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">MnR</label>
                                        </div>
                                        <div className="flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('OTHERS') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_category?.includes('OTHERS')}
                                                onChange={() => HandleFilter('order_category', 'OTHERS')}
                                                borderColor={`${Filter.order_category?.includes('OTHERS') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="xs4" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trading</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'type' ? 'show active' : ''} fade w-full px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                                    <div className="cursor-pointer">
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('Trade EUB') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('Trade EUB')}
                                                onChange={() => HandleFilter('type', 'Trade EUB')}
                                                borderColor={`${Filter.type?.includes('Trade EUB') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn50" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trade EUB</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('Trade') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('Trade')}
                                                onChange={() => HandleFilter('type', 'Trade')}
                                                borderColor={`${Filter.type?.includes('Trade') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn51" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trade</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('Demo') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('Demo')}
                                                onChange={() => HandleFilter('type', 'Demo')}
                                                borderColor={`${Filter.type?.includes('TRADE') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn52" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Demo</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('Domestic') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('Domestic')}
                                                onChange={() => HandleFilter('type', 'Domestic')}
                                                borderColor={`${Filter.type?.includes('Domestic') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn53" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Domestic</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('service') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('service')}
                                                onChange={() => HandleFilter('type', 'service')}
                                                borderColor={`${Filter.type?.includes('service') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn54" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Service Parts</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('Free') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('Free')}
                                                onChange={() => HandleFilter('type', 'Free')}
                                                borderColor={`${Filter.type?.includes('Free') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn55" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Free Sample</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'date_range' ? 'show active' : ''} fade  px-3`} id="pilldaterange" role="tabpanel" aria-labelledby="pills-daterange">
                                    <div className="relative" ref={dateRef}>
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                />
                                            </div>
                                            {toggle.start_date && (
                                                <Calendar
                                                    value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                                    onChange={(val) => handleDate(val, 'start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && (
                                                <Calendar
                                                    value={selected.end_date}
                                                    onChange={(val) => handleDate(val, 'end_date')}
                                                    minDate={moment(selected.start_date).toDate()}
                                                    placeholder="Date to"
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[35%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}

                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IndentFilterModal;
